export enum NodeContentTypeEnum {
  ScalarContent = 1,
  RawBinaryContent = 2,
  InputValueContent = 3,
  PreviousContent = 4,
}
